import { UseMutationOptions } from '@tanstack/react-query';
import useGlobalStore from '@/stores/global.store';
import { CustomerFormValues } from '@/types/customer-form-values';
import { useUpdateOrderCustomerMutation } from './use-update-order-customer';

type TData = void;
type TVariables = { orderId: string; customer: CustomerFormValues };

export function useUpdateCurrentOrderCustomerMutation(options?: UseMutationOptions<TData, Error, TVariables>) {
  const orderId = useGlobalStore((state) => state.orderId);

  if (!orderId) throw new Error('No order to update');

  const mutation = useUpdateOrderCustomerMutation(options);

  return { ...mutation, mutate: (customer: CustomerFormValues) => mutation.mutate({ orderId, customer }) };
}
